import {IPlansRepository} from './IPlansRepository';

// OLD CODE - Commented out (kept for reference)
// import {customPlan} from './PlansQueries';
// import {createPlan, updatePlan} from './PlansMutation';
// import {PlanInsert, Plan} from '../../graphql/API';
// import {generateClient} from 'aws-amplify/api';

// NEW CODE - Using @PikaDoApp/npm-pikado-logic
import {
  InitWithAmplify,
  InitEnvironmentVariable,
  PlansService as PikadoPlansService,
} from '@PikaDoApp/npm-pikado-logic';
import {
  NewCreatePlanInput,
  NewUpdatePlanInput,
  AddExerciseToDayInput,
  RemoveExerciseFromDayInput,
  ReplaceExerciseInDayInput,
} from '@PikaDoApp/npm-pikado-logic/dist/modules/plan/graphql/plan.interface';
import {Amplify} from 'aws-amplify';
import {getEnvironment} from '../../lib/getEnvironment';

// const client = generateClient();

// NEW CODE - Initialize pikado-logic package
InitWithAmplify(Amplify);
InitEnvironmentVariable(getEnvironment());
const pikadoPlansService = new PikadoPlansService();

export class PlansRepository implements IPlansRepository {
  // ========================================
  // OLD CODE - Commented out (kept for reference)
  // ========================================
  // async createPlan(plan: PlanInsert): Promise<Plan> {
  //   try {
  //     const response: GraphQLResult<any> = await client.graphql({
  //       query: createPlan,
  //       variables: {
  //         input: plan,
  //       },
  //     });
  //     //console.log('createPackageResponse->', response);
  //
  //     return JSON.parse(response.data?.createPlan);
  //   } catch (error) {
  //     //console.log('create plan Error: ', error);
  //     throw new Error(error);
  //   }
  // }
  //
  // async getPlanById(planId: string): Promise<any> {
  //   try {
  //     const response: GraphQLResult<any> = await client.graphql({
  //       query: customPlan,
  //       variables: {
  //         id: planId,
  //       },
  //     });
  //
  //     return response.data?.plan;
  //   } catch (error) {
  //     console.log('Fetch plan Error: ', error);
  //     throw new Error(error);
  //   }
  // }
  //
  // async updatePlan(
  //   planId: string,
  //   updatedAt: string,
  //   newPlan: string,
  // ): Promise<any> {
  //   //console.log('newPlan', newPlan);
  //   try {
  //     const updatePlanResponse: GraphQLResult<any> = await client.graphql({
  //       query: updatePlan,
  //       variables: {
  //         id: planId,
  //         updatedAt: updatedAt,
  //         input: {newPlan},
  //       },
  //     });
  //     //console.log('updatePlanResponse->', updatePlanResponse);
  //
  //     return null;
  //   } catch (error) {
  //     //console.log('Fetch plan Error: ', error);
  //     throw new Error(error);
  //   }
  // }
  //
  // async getDayPlan(planId: string, day: number): Promise<Plan> {
  //   let planDayQuery = `
  //   query Plan($id: String!) {
  //     plan(id: $id) {
  //       id
  //       d${day} {
  //         id
  //         createdAt
  //         updatedAt
  //         type
  //         name
  //         name_i18n
  //         description
  //         summary
  //         asset {
  //             id
  //             createdAt
  //             updatedAt
  //             type
  //             thumbnailUri
  //             fileUri
  //             title_i18n
  //             subTitle_i18n
  //             position
  //   }
  //         questions {
  //         id
  //         createdAt
  //         updatedAt
  //         name
  //         summary
  //         description
  //         text
  //         type
  //        }
  //       }
  //     }
  //   }
  // `;
  //
  //   try {
  //     const response: GraphQLResult<any> = await client.graphql({
  //       query: planDayQuery,
  //       variables: {
  //         id: planId,
  //       },
  //     });
  //     return response.data?.plan;
  //   } catch (error) {
  //     console.log('Fetch plan day Error: ', error);
  //     throw new Error(error);
  //   }
  // }

  // ========================================
  // NEW CODE - Using @PikaDoApp/npm-pikado-logic
  // ========================================

  // Core CRUD Operations
  async newCreatePlan(input: NewCreatePlanInput): Promise<any> {
    try {
      console.log('🔍 [PLAN] Creating new plan with input:', input);
      const createdPlan = await pikadoPlansService.newCreatePlan(input);
      console.log('✅ [PLAN] Plan created successfully:', createdPlan);

      // Transform _id to id for UI compatibility
      return {
        id: createdPlan._id,
        ...createdPlan,
      };
    } catch (error) {
      console.error('❌ [PLAN] Error creating plan:', error);
      throw new Error(error);
    }
  }

  async newUpdatePlan(input: NewUpdatePlanInput): Promise<any> {
    try {
      console.log('🔍 [PLAN] Updating plan with input:', input);
      const updatedPlan = await pikadoPlansService.newUpdatePlan(input);
      console.log('✅ [PLAN] Plan updated successfully:', updatedPlan);

      // Transform _id to id for UI compatibility
      return {
        id: updatedPlan._id,
        ...updatedPlan,
      };
    } catch (error) {
      console.error('❌ [PLAN] Error updating plan:', error);
      throw new Error(error);
    }
  }

  async getNewPlanById(id: string): Promise<any> {
    try {
      console.log('🔍 [PLAN] Fetching plan by id:', id);
      const plan = await pikadoPlansService.getNewPlanById(id);
      console.log('✅ [PLAN] Plan fetched successfully:', plan);

      if (!plan) {
        return null;
      }

      // Transform _id to id for UI compatibility
      return {
        id: plan._id,
        ...plan,
      };
    } catch (error) {
      console.error('❌ [PLAN] Error fetching plan:', error);
      throw new Error(error);
    }
  }

  async findAllPlans(): Promise<any[]> {
    try {
      console.log('🔍 [PLAN] Fetching all plans');
      const plans = await pikadoPlansService.findAllPlans();
      console.log('✅ [PLAN] Plans fetched successfully. Count:', plans.length);

      // Transform _id to id for UI compatibility
      return plans.map((plan) => ({
        id: plan._id,
        ...plan,
      }));
    } catch (error) {
      console.error('❌ [PLAN] Error fetching all plans:', error);
      throw new Error(error);
    }
  }

  async deletePlan(id: string): Promise<boolean> {
    try {
      console.log('🔍 [PLAN] Deleting plan with id:', id);
      const result = await pikadoPlansService.deletePlan(id);
      console.log('✅ [PLAN] Plan deleted successfully:', result);
      return result;
    } catch (error) {
      console.error('❌ [PLAN] Error deleting plan:', error);
      throw new Error(error);
    }
  }

  // Query Operations
  async getPlanByLevelAndCurriculum(
    levelId: string,
    curriculumId: string,
  ): Promise<any> {
    try {
      console.log(
        '🔍 [PLAN] Fetching plan by level and curriculum:',
        levelId,
        curriculumId,
      );
      const plan = await pikadoPlansService.getPlanByLevelAndCurriculum(
        levelId,
        curriculumId,
      );
      console.log('✅ [PLAN] Plan fetched successfully:', plan);

      if (!plan) {
        return null;
      }

      // Transform _id to id for UI compatibility
      return {
        id: plan._id,
        ...plan,
      };
    } catch (error) {
      console.error('❌ [PLAN] Error fetching plan by level and curriculum:', error);
      throw new Error(error);
    }
  }

  async getPlansByCurriculum(curriculumId: string): Promise<any[]> {
    try {
      console.log('🔍 [PLAN] Fetching plans by curriculum:', curriculumId);
      const plans = await pikadoPlansService.getPlansByCurriculum(curriculumId);
      console.log('✅ [PLAN] Plans fetched successfully. Count:', plans.length);

      // Transform _id to id for UI compatibility
      return plans.map((plan) => ({
        id: plan._id,
        ...plan,
      }));
    } catch (error) {
      console.error('❌ [PLAN] Error fetching plans by curriculum:', error);
      throw new Error(error);
    }
  }

  // Daily Exercise Management
  async addExerciseToDay(input: AddExerciseToDayInput): Promise<any> {
    try {
      console.log('🔍 [PLAN] Adding exercise to day with input:', input);
      const updatedPlan = await pikadoPlansService.addExerciseToDay(input);
      console.log('✅ [PLAN] Exercise added successfully:', updatedPlan);

      // Transform _id to id for UI compatibility
      return {
        id: updatedPlan._id,
        ...updatedPlan,
      };
    } catch (error) {
      console.error('❌ [PLAN] Error adding exercise to day:', error);
      throw new Error(error);
    }
  }

  async removeExerciseFromDay(input: RemoveExerciseFromDayInput): Promise<any> {
    try {
      console.log('🔍 [PLAN] Removing exercise from day with input:', input);
      const updatedPlan = await pikadoPlansService.removeExerciseFromDay(input);
      console.log('✅ [PLAN] Exercise removed successfully:', updatedPlan);

      // Transform _id to id for UI compatibility
      return {
        id: updatedPlan._id,
        ...updatedPlan,
      };
    } catch (error) {
      console.error('❌ [PLAN] Error removing exercise from day:', error);
      throw new Error(error);
    }
  }

  async replaceExerciseInDay(input: ReplaceExerciseInDayInput): Promise<any> {
    try {
      console.log('🔍 [PLAN] Replacing exercise in day with input:', input);
      const updatedPlan = await pikadoPlansService.replaceExerciseInDay(input);
      console.log('✅ [PLAN] Exercise replaced successfully:', updatedPlan);

      // Transform _id to id for UI compatibility
      return {
        id: updatedPlan._id,
        ...updatedPlan,
      };
    } catch (error) {
      console.error('❌ [PLAN] Error replacing exercise in day:', error);
      throw new Error(error);
    }
  }

  async getDailyExercisesByPlanAndDay(planId: string, dayNumber: number): Promise<any[]> {
    try {
      console.log('🔍 [PLAN] Fetching daily exercises for plan:', planId, 'day:', dayNumber);
      const exercises = await pikadoPlansService.getDailyExercisesByPlanAndDay(planId, dayNumber);
      console.log('✅ [PLAN] Daily exercises fetched successfully. Count:', exercises?.length || 0);

      if (!exercises || exercises.length === 0) {
        return [];
      }

      // Transform _id to id for UI compatibility
      return exercises.map((exercise) => ({
        id: exercise._id,
        ...exercise,
      }));
    } catch (error) {
      console.error('❌ [PLAN] Error fetching daily exercises by plan and day:', error);
      throw new Error(error);
    }
  }
}
